import React, { useRef } from 'react';
import './FeaturedServices.css';

const services = [
  { id: 1, name: 'Academic', icon: '🎓' },
  { id: 2, name: 'Agriculture', icon: '🌾' },
  { id: 3, name: 'Art', icon: '🎨' },
  { id: 4, name: 'Beauty & Fashion', icon: '💄' },
  { id: 5, name: 'Business', icon: '💼' },
  { id: 6, name: 'Finance', icon: '💰' },
  { id: 7, name: 'Health', icon: '🏥' },
  { id: 8, name: 'Industries', icon: '🏭' },
  { id: 9, name: 'Life Skills', icon: '🌱' },
  { id: 10, name: 'Medicine', icon: '⚕️' },
  { id: 11, name: 'Technology', icon: '💻' },
  { id: 12, name: 'Sport', icon: '⚽' },
  { id: 13, name: 'Much More', icon: '➕' },
];

const FeaturedServices = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth * 0.9; // Adjust scrolling amount if needed
      scrollRef.current.scrollTo({
        left: direction === 'left' ? scrollLeft - scrollAmount : scrollLeft + scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="featured-services">
      <h2 className="section-title">Categories</h2>
      <div className="carousel-controls">
        <button onClick={() => scroll('left')} className="arrow left">‹</button>
        <div className="services-scroll" ref={scrollRef}>
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <span className="service-icon">{service.icon}</span>
              <h3>{service.name}</h3>
            </div>
          ))}
        </div>
        <button onClick={() => scroll('right')} className="arrow right">›</button>
      </div>
    </section>
  );
};

export default FeaturedServices;
